import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import React from 'react'
const Restrict = props => {
  // props for this file from parent
  const { sendBooleanValueChangeDone, sendrestrit, inputData } = props
  // state variables for this file
  const [showPopUp, setshowPopUp] = useState(false)
  const agerestriction = ['U', 'U/A', 'A', 'S']

  const restrictback1 = agerestriction.map((e, index) => (
    <div key={index} className='restrictionage1'>
      {/* {console.log(restrit === e, 'restricval')} */}
      <div
        onClick={() => {
          /* props.sendrestrit(e.value)  */
          sendBooleanValueChangeDone('ageRestrict', true)
          sendrestrit('restrit', e)
          setshowPopUp(false)
        }}
        className={`restrictionage ${props.restrit === e ? 'restrictionage2' : ''}`}
      >
        {/* {e.label} */}
        {e}
      </div>
      <div className='space10'></div>
    </div>
  ))
  // function to handle the change in value
  const restrict = event => {
    sendBooleanValueChangeDone('ageRestrict', true)
    sendrestrit('restrit', event.target.value)
  }

  // function to show popup
  const restrictShowPopUp = () => {
    if (showPopUp === true) {
      setshowPopUp(false)
    } else {
      setshowPopUp(true)
    }
  }

  return (
    <div>
      <div className='shotbio  margintop'>
        <label>
          Age Restriction:<div className='mandatory'>*</div>
        </label>
        <input
          type='text'
          className='form-control'
          style={{ width: '50%' }}
          placeholder={`select Agerestriction of ${
            inputData.contentType === 'movies' ? 'movie' : 'webseries'
          }`}
          value={props.restrit}
          onChange={event => restrict(event)}
          onClick={() => restrictShowPopUp()}
        />
      </div>
      {!props.restrit && <span className='mandatory1'>Agerestriction Should not be empty</span>}
      {showPopUp && (
        <Modal show={restrictShowPopUp} fullscreen={'md-down'} onHide={() => setshowPopUp(false)}>
          <Modal.Header closeButton>
            <Modal.Title>restrict</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>{restrictback1}</div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  )
}

export default Restrict
